import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GatewayStore, InstallationFeaturesStore } from '@store';
import { CommissioningService } from '../commissioning.service';

export interface CloseEventDialog {
  confirmed: boolean;
  shouldDeactivateSRC: boolean;
}

@Component({
  selector: 'app-commissioning-delete-device-confirm-modal',
  templateUrl: './commissioning-delete-device-confirm-modal.component.html',
  styleUrls: ['./commissioning-delete-device-confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommissioningDeleteDeviceConfirmModalComponent implements OnInit {
  readonly TITLE_KEY = '+SRC_COMMISSIONINGV2.DELETE_DEVICE_TITLE';
  readonly NORMAL_MESSAGE_KEY = '+SRC_COMMISSIONINGV2.DELETE_DEVICE_CONFIRM_TEXT';
  readonly LAST_DEVICE_MESSAGE_KEY = '+SRC_COMMISSIONINGV2.DELETE_DEVICE_LAST_DEVICE_CONFIRM_TEXT';

  shouldDeactivateSRC = false;

  constructor(
    public dialogRef: MatDialogRef<CommissioningDeleteDeviceConfirmModalComponent>,
    public commissioningService: CommissioningService,
    public gatewayStore: GatewayStore,
    public installationFeaturesStore: InstallationFeaturesStore,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      deviceId: string;
      titleKey?: string;
      normalMessageKey?: string;
      lastDeviceMessageKey?: string;
    }
  ) {}

  getTitleMessageKey(): string {
    return this.data?.titleKey ? this.data.titleKey : this.TITLE_KEY;
  }

  getNormalMessageKey(): string {
    return this.data?.normalMessageKey ? this.data.normalMessageKey : this.NORMAL_MESSAGE_KEY;
  }

  getLastDeviceMessageKey(): string {
    this.shouldDeactivateSRC = true;

    return this.data?.lastDeviceMessageKey
      ? this.data.lastDeviceMessageKey
      : this.LAST_DEVICE_MESSAGE_KEY;
  }

  ngOnInit(): void {
    this.dialogRef.updateSize('720px');
  }

  onCancel(): void {
    this.dialogRef.close({
      confirmed: false,
      shouldDeactivateSRC: false,
    });
  }

  onConfirm(): void {
    this.dialogRef.close({
      confirmed: true,
      shouldDeactivateSRC: this.shouldDeactivateSRC,
    });
  }
}
